import React, {useState} from 'react'
import {useParams} from 'react-router-dom'
import {Typography} from '@material-ui/core'
import * as Api from 'lib/api'
import {ProductDetail} from 'components/organisms/products'

export default function ProductDetailPage() {
  const {id} = useParams()

  const [isLoading, setIsLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState(null)
  const [product, setProduct] = useState(null)

  React.useEffect(() => {
    async function fetchData() {
      const result = await Api.getProductById(id)
      result.matchWith({
        Ok: ({value}) => {
          setProduct(value)
        },
        Error: ({value}) => {
          setErrorMessage(value.message)
        },
      })
      setIsLoading(false)
    }

    fetchData()
  }, [id])

  if (isLoading) {
    return <Typography variant="h5" component="h2">Loading...</Typography>
  }

  if (errorMessage) {
    return <Typography variant="h5" component="h2" color="error">Something went wrong!</Typography>
  }

  return <ProductDetail product={product} />
}
